/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const SadIcon = props => {
	const { color = '' } = props
	return (
		<svg
			id='Layer_1'
			xmlns='http://www.w3.org/2000/svg'
			x={0}
			y={0}
			viewBox='0 0 50 50'
			style={{
				enableBackground: 'new 0 0 50 50'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			fill={color}
			{...props}
		>
			<path
				className='st0'
				d='M25 0C11.2 0 0 11.2 0 25s11.2 25 25 25 25-11.2 25-25S38.8 0 25 0zm0 48.2C12.2 48.3 1.8 37.8 1.8 25 1.8 12.2 12.2 1.8 25 1.8c12.8 0 23.2 10.4 23.3 23.2 0 12.8-10.4 23.2-23.3 23.2z'
			/>
			<path
				className='st0'
				d='M25.2 28.2c-4 0-7.5 2.6-8.7 6.4v.3c0 .3.1.7.4.9.2.2.6.4.9.4.6 0 1.1-.4 1.2-.9.9-2.8 3.4-4.6 6.3-4.6 2.8 0 5.4 1.8 6.2 4.5.2.7.9 1.1 1.5.9.3-.1.6-.3.8-.6.2-.3.2-.6.1-1-1.2-3.7-4.7-6.3-8.7-6.3zM20.9 19.6c.2-.3.2-.6.1-1-.1-.3-.3-.6-.6-.8-.6-.3-1.4-.1-1.7.5-1.4 2.2-5.3 3.2-5.5 3.2-.6.1-1 .6-1 1.2 0 .3.1.7.4.9.2.2.5.4.9.4h.3c.1 0 5.1-1.1 7.1-4.4zM37.6 22.1c-.2-.3-.5-.5-.8-.6 0 0-4.1-.9-5.5-3.2-.4-.6-1.2-.7-1.7-.4-.3.2-.5.5-.5.8-.1.3 0 .7.2.9 2 3.2 6.9 4.3 7.1 4.3h.2c.6 0 1.1-.4 1.2-1 0-.2 0-.5-.2-.8zm-1.1 1.4z'
			/>
		</svg>
	)
}

export default SadIcon
